module.exports = __webpack_public_path__ + "img/124.3.b342880d.png";